import type { ReactElement } from 'react';
import CollectionSelectorListItem, {
  type CollectionSelectorListItemProps,
} from './CollectionSelectorListItem';

export { CollectionSelectorListItem, type CollectionSelectorListItemProps };

export type CollectionSelectorListProps = {
  className?: string;
  children: ReactElement<
    CollectionSelectorListItemProps,
    typeof CollectionSelectorListItem
  >[];
};

export default function CollectionSelectorList({
  className,
  children,
}: CollectionSelectorListProps) {
  return <ul className={className}>{children}</ul>;
}
